module.exports = __webpack_public_path__ + "static/1-bdbaedee98a7a7c2d09110609308031d.jpg";